import React from 'react'
import { useGtXs } from '../../hooks/useGtXs'
import DesktopHeader from '../DesktopHeader/DesktopHeader'
import MobileHeader from '../MobileHeader/MobileHeader'

export default function Header() {
    const gtXs = useGtXs()
    return gtXs ? <DesktopHeader /> : <MobileHeader />;
}
